import { IoMdAdd, IoMdClose } from "react-icons/io";
import {
  ProjectCloseButton,
  ProjectCreateContainer,
  ProjectSection,
} from "./component/common/styled/project";
import { GrTemplate } from "react-icons/gr";
import { useLocation, useNavigate } from "react-router";

export default function ProjectCreate() {
  const navigate = useNavigate();
  const location = useLocation();

  const eventInfo = location?.state?.eventInfo;
  const navigatePath = location?.state?.navigatePath;

  const options = [
    {
      key: "manual",
      label: "직접 만들기",
      icon: <IoMdAdd />,
      onClick: () =>
        navigate(
          "/mypage/projectCreateSec",
          eventInfo ? { state: { eventInfo, navigatePath } } : undefined,
        ),
    },
  ];

  return (
    <ProjectSection>
      <ProjectCloseButton
        onClick={() =>
          navigatePath ? navigate(navigatePath, { state: { eventInfo } }) : navigate("/mypage")
        }>
        <IoMdClose />
      </ProjectCloseButton>
      <ProjectCreateContainer>
        <div className="inner">
          <div className="info">
            <span>프로젝트 만들기</span>
            <p>프로젝트를 어떻게 만들지 선택해보세요.</p>
          </div>
          <div className="selectButtons">
            {options.map((opt) => (
              <button key={opt.key} onClick={opt.onClick}>
                <div className="icon">{opt.icon}</div>
                <span>{opt.label}</span>
              </button>
            ))}
          </div>
        </div>
      </ProjectCreateContainer>
    </ProjectSection>
  );
}
